import { DREnums, DRTypes } from '../../Requirement';
import { Actions } from '../../Actions/Actions';
import { Targets } from '../../Targets/Targets';
import { Policies } from '../../Policies/Policies';
import { Metrics } from '../Metrics/Metrics';

export const DisclosureRequirement = ({
  type,
  setMetricSidebarOpen,
}: {
  type: DRTypes;
  setMetricSidebarOpen: (val: boolean) => void;
}) => {
  if (type === DREnums.policy) {
    return <Policies setMetricSidebarOpen={setMetricSidebarOpen} />;
  }
  if (type === DREnums.target) {
    return <Targets setMetricSidebarOpen={setMetricSidebarOpen} />;
  }
  if (type === DREnums.metric) {
    return <Metrics />;
  }
  if (type === DREnums.action) return <Actions setMetricSidebarOpen={setMetricSidebarOpen} />;
  return <Metrics />;
};
